export class ChatAppMessageProperties {
  uniqueId: string;
  messageId: number; 
  userId: number; 
  sender: string;
  content: string;
  senderName: string;
  timestamp: string;
  creationDate: string;
  isFile: boolean = false;
  isImage: boolean = false;
  fileUrl: string[]=[]; 
  files: File[]=[];
  date: string;
  dateChanged: boolean = false;
  seen: boolean = false;
}

export class BasicDataForChatRequired {
  property1: string;
  property2: string;
  property3: string;
}
